export type RoleAccent = 'blue' | 'orange' | 'red' | 'purple' | 'emerald' | 'sky' | 'amber' | 'indigo' | 'teal';

export const ROLE_ACCENT: Record<RoleAccent, { icon: string; ring: string }> = {
    blue: { icon: 'bg-blue-500', ring: 'ring-blue-100' },
    orange: { icon: 'bg-orange-500', ring: 'ring-orange-100' },
    red: { icon: 'bg-red-500', ring: 'ring-red-100' },
    purple: { icon: 'bg-purple-500', ring: 'ring-purple-100' },
    emerald: { icon: 'bg-emerald-500', ring: 'ring-emerald-100' },
    sky: { icon: 'bg-sky-500', ring: 'ring-sky-100' },
    amber: { icon: 'bg-amber-500', ring: 'ring-amber-100' },
    indigo: { icon: 'bg-indigo-500', ring: 'ring-indigo-100' },
    teal: { icon: 'bg-teal-500', ring: 'ring-teal-100' },
};

export function roleAccent(color: string) {
    return ROLE_ACCENT[color as RoleAccent] ?? ROLE_ACCENT.blue;
}
